import lazyComponent from '../../../utils/lazyComponent';
import { DetailSearchModalProps } from './types/DetailSearchModalProps';

const LazyDetailSearchModal = lazyComponent<DetailSearchModalProps>(
  () => import('./DetailSearchModal')
);

export default LazyDetailSearchModal;
